import * as Sentry from '@sentry/vue';
import L from 'leaflet';
import 'leaflet-defaulticon-compatibility';
import {App} from 'vue';
import './polyfills';

// @vue-leaflet/vue-leaflet with useGlobalLeaflet:true (default) reads Leaflet
// from window.L. Webpack module imports don't set globals, so we must do it.
(window as any).L = L;

export function configureApp(app: App): void {
    const originalErrorHandler = app.config.errorHandler;
    app.config.errorHandler = (error, instance, info) => {
        Sentry.captureException(error);
        if (typeof originalErrorHandler === 'function') {
            originalErrorHandler(error, instance, info);
        } else {
            console.error(error);
        }
    };
}
